<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    :class="{ 'admin': isAdmin && user.view === 'admin', 'user': user.view === 'user' }"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="270"
  >
    <v-img
      :src="drawerBg"
      height="100%">
      <v-layout
        class="fill-height"
        tag="v-list"
        column>
        <v-list-tile avatar>
          <v-list-tile-avatar color="white">
            <v-img
              :src="logo"
              height="41"
              contain/>
          </v-list-tile-avatar>

          <v-list-tile-title class="title">
            AWS Galaxy
            <br>Account Inventory
          </v-list-tile-title>
        </v-list-tile>

        <v-divider/>

        <v-list-tile v-if="responsive">
          <v-text-field
            class="purple-input search-input"
            label="Search..."
            color="orange"/>
        </v-list-tile>
        <v-expansion-panel
          v-for="(menu, i) in menus"
          :key="i"
          v-model="menus[i].expand"
          expand>
          <v-expansion-panel-content append-icon>
            <template
              v-slot:header
              append-icon>
              <v-list-tile
                avatar
                class="v-list-item">
                <v-list-tile-action>
                  <v-icon>{{ menu.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title
                  :class="menu.class"
                  v-text="menu.text"
                />
              </v-list-tile>
            </template>
            <template>
              <v-radio-group
                :value="selectedFilterRoute"
                class="menu-radio-group"
                @change="onFilterChange"
              >
                <v-radio
                  v-for="(option,i) in menu.items"
                  :key="i"
                  :label="option.label"
                  :value="option.route"
                  color="warning"
                />
              </v-radio-group>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <div v-if="user.view === 'user'" class="new-masterpayer-link">
          <router-link to="/request-new-masterpayer"><v-icon>mdi-account-plus</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;Request New Masterpayer</router-link>
        </div> -->
        <div class="internal-content-text">
          <p>Email the support team for all questions and to report application issues at
GuardiansoftheGalaxy@dxc.com.<br />All content herein is for DXC Internal use only.</p>
        </div>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from 'vuex'
import { checkRoutePermission, checkSubRoutePermission } from '@/utils/helper'

export default {
  props: ['isAdmin', 'user'],
  data () {
    return {
      responsive: null
    }
  },
  computed: {
    ...mapState('app', ['drawerBg', 'color', 'logo', 'selectedFilter', 'adminmenus', 'financemenus', 'usermenus', 'drawer']),
    menus () {
      const menus = this.isAdmin && this.user.view === 'admin' ? this.adminmenus : this.usermenus
      const dataMenu = menus.filter(item => checkRoutePermission(item.to))
      dataMenu.forEach(item => {
        if (item.items) {
          item.items = item.items.filter(subItem => checkSubRoutePermission(subItem.route))
        }
      })
      return dataMenu
    },
    inputValue: {
      get () {
        return this.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    selectedFilterRoute: {
      get () {
        return this.selectedFilter
      },
      set (val) {
        this.setSelectedFilter(val)
      }
    }
  },

  watch: {
    $route (to, from) {
      this.determineMenuState()
    }
  },

  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
    this.determineMenuState()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer', 'setSelectedFilter']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    },
    onFilterChange (route) {
      this.selectedFilterRoute = route
      this.$router.push({ path: route })
    },
    determineMenuState () {
      if (!this.selectedFilter) {
        return
      }
      let route = this.$router.history.pending || this.$router.history.current
      if (route.path === '/') {
        return this.selectedFilterRoute = '/'
      }
      let urlParts = route.path.split('/')
      let self = this
      if (urlParts[1] !== '') {
        let currentMenu = urlParts[1] === 'admin' ? `/${urlParts[1]}/${urlParts[2]}` : `/${urlParts[1]}`
        let menus = this.menus.map((menu, index) => {
          menu.expand = menu.to === currentMenu ? [true] : [false]
          if (menu.expand[0]) {
            let exactRoute = urlParts[1] === 'admin' ? `/${urlParts[1]}/${urlParts[2]}/${urlParts[3]}` : `/${urlParts[1]}/${urlParts[2]}`
            if (menu.hasOwnProperty('items')) {
              menu.items = menu.items.map((menuBy, index) => {
                if (menuBy.route === `${exactRoute}`) {
                  self.selectedFilterRoute = menuBy.route
                }
                return menuBy
              })
            }
          }
          return menu
        })
      }
    }
  }
}
</script>

<style lang="scss">
#app-drawer {
  &.admin {
    background-image: none;
    background: #7e7e7e;
  }
  &.user {
    background-image: none;
    background: #000;
  }

  .menu-radio-group {
    .v-label:hover {
      color: #ff9900;
    }
  }

  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }

  .v-list-item {
    border-radius: 5px;
  }
  .v-list__tile__action {
    margin-right: 10px;
  }
  .v-expansion-panel {
    box-shadow: none;
    .v-expansion-panel__container--active {
      .v-list__tile {
        background-color: #ff9900 !important;
        box-shadow: 0 12px 20px -10px rgba(255, 153, 0, 0.28),
          0 4px 20px 0px rgba(0, 0, 0, 0.12),
          0 7px 8px -5px rgba(255, 153, 0, 0.2) !important;
      }
    }
    .v-expansion-panel__header {
      padding: 0px;
      display: block;
      .v-expansion-panel__header__icon {
        display: none;
      }
    }
    .v-expansion-panel__container {
      background: none;
    }
  }
  .v-input--selection-controls .v-input__control {
    margin: 0;
    width: 100%;
  }
  .v-radio {
    margin-left: 16px;
  }
  .padding-lr-15 {
    padding-right: 15px;
    padding-left: 15px;
  }

  .internal-content-text {
    display: flex;
    align-items: flex-end;
    flex: auto;
    justify-content: center;

    p {
      font-weight: bold;
      font-size: 15px !important;
      text-align: center;
      padding: 0 10px;
    }
  }
  .customer-owned-accounts {
    overflow: unset!important;
    text-wrap: auto!important;
  }
  // .new-masterpayer-link {
  //   margin: 15px 25px 0 30px;
  //   > a {
  //     font-size: 14px;
  //     color: #fff;
      
  //   }
    
  // }
}
</style>
